<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-modal
                    :buttons="['cancel']"
                    large
                    ref="Modal"
                    title="Detalhes"
                >
                    <rkm-table
                        :fields="fields"
                        :items="items"
                        hide-filters
                        hide-pagination
                        thead-class="d-none"
                    />

                    <ModalHistoricoMedico ref="ModalHistoricoMedico" />

                    <rkm-row v-if="solicitacao && solicitacao.soapId && model">
                        <rkm-col class="text-right">
                            <rkm-button
                                v-if="hasPermissao('show-ambulatorio-historico-atendimento')"
                                :label="false"
                                @click.stop="$refs.ModalHistoricoMedico.open(model)"
                                color="primary"
                            >
                                Visualizar histórico de atendimento
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-modal>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import ModalHistoricoMedico from '@/components/regulacao/solicitacao/components/historico-atendimento-ambulatorio/Modal'

// Vuex.
import {mapActions} from 'vuex'

// Mixins.
import { permissao, repository } from '@/mixins'

export default {
    components: {
        ModalHistoricoMedico,
    },
    computed: {
        fields() {

            return [
                {
                    key: "field",
                    class: "font-weight-bold col-min",
                },
                {
                    key: "value",
                },
            ]
        }
    },
    created() {
        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila')
        }
    },
    data: () => ({
        items: [],
        model: null,
        solicitacao: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {

            this.items = [
                {
                    field: 'Unidade solicitante',
                    value: item.unidadeSolicitanteNomeFantasia,
                },
                {
                    field: 'Local de atendimento solicitante',
                    value: item.infraestruturaSolicitanteNome,
                },
                {
                    field: 'Profissional solicitante',
                    value: item.usuarioSolicitanteNome,
                },
                {
                    field: 'HD',
                    value: item.hipoteseDiagnosticaJustificativa,
                },
                {
                    field: 'Data do agendamento',
                    value: item.agendamento,
                },
                {
                    field: 'Usuário que registrou a solicitação',
                    value: item.usuarioRegistrouSolicitacaoNome,
                },
                {
                    field: 'Justificativa da devolução',
                    value: item.justificativaDevolucao,
                },
            ]

            this.solicitacao = item;
            if (this.solicitacao.soapId) this.load();

            this.$refs.Modal.show()
        },
        hasPermissao(hash) {
            return this.verificarPermissao(hash);
        },
        load() {
            this.setLoading()

            this.repositories.fila.getDadosAmbulatorio(this.solicitacao.id)
                .then(response => {

                    this.model = response.data.form;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [permissao, repository],
}
</script>